// Phase 6 — Floating master chat button. Visible on every page of
// every shell (V1/V2/V3/V4). One tap opens the Messages view.
// Carries an unread-message badge that pulses gold when new
// messages arrive.

import React from "react";
import { MessageSquare } from "lucide-react";

export default function ChatFab({ active, unread, onOpen }) {
  // Hide ourselves while the user is already on the Messages view —
  // the FAB would just be redundant noise there.
  if (active === "messages") return null;
  return (
    <button
      type="button"
      className={unread > 0 ? "chatFab chatFab--unread" : "chatFab"}
      onClick={onOpen}
      title={unread > 0 ? `Open Messages (${unread} unread)` : "Open Messages"}
      aria-label={unread > 0 ? `Open Messages, ${unread} unread` : "Open Messages"}
    >
      <MessageSquare size={22}/>
      {unread > 0 && (
        <span className="chatFab-badge">
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </button>
  );
}
